/**
 * MessageBar React component
 * 
 * @author    Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


import React from 'react';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import {clearMessage} from '../../operations/message';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
    close: {
        padding: theme.spacing.unit / 2,
    },
});


export class MessageBar extends React.Component {

    render() {

        const props = this.props;

        return (
            <Snackbar
                open={props.open}
                message={props.message}
                autoHideDuration={4000}
                onClose={props.clearMessage}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                action={[
                    <IconButton
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        className={props.close}
                        onClick={props.clearMessage}
                    >
                        <CloseIcon/>
                    </IconButton>
                ]}
            />
        );
    }
}

export default connect((state) => {
    return {
        message: state.messages.message,
        open: state.messages.showMessage
    }
}, {clearMessage})(withStyles(styles)(MessageBar))